import { useEffect, useState } from "@/utils/hooks/reactUseCustomHooks";
/**  Check if user is Offliine  */
const useNetwork = () => {
  const [isOnline, setIsOnline] = useState(
    typeof window !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const updateNetwork = () => setIsOnline(navigator.onLine);

    window.addEventListener("online", updateNetwork);
    window.addEventListener("offline", updateNetwork);

    return () => {
      window.removeEventListener("online", updateNetwork);
      window.removeEventListener("offline", updateNetwork);
    };
  }, []);

  return isOnline;
};

export default useNetwork;
